import { render, staticRenderFns } from "./ConfigureShiftWorkListViewOld.vue?vue&type=template&id=a19440b0&scoped=true"
import script from "./ConfigureShiftWorkListViewOld.vue?vue&type=script&lang=js"
export * from "./ConfigureShiftWorkListViewOld.vue?vue&type=script&lang=js"
import style0 from "./ConfigureShiftWorkListViewOld.vue?vue&type=style&index=0&id=a19440b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19440b0",
  null
  
)

export default component.exports